module.exports = " <li class=tabs-title :class=\"{ 'is-active': active }\"><a href=# :aria-selected=active @click=click>{{ text }}</a></li> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/race-schedule/components/Tab.vue
 ** module id = 124
 ** module chunks = 1
 **/